import { Link } from 'react-router-dom';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconChart, IconEdit } from '../../../common/icons';
import { fmtMoney } from '../../../common/utils/money';

import '../../../common/styles/catalog.css';
import '../styles/detail.css';
import '../styles/holdings.css';

// Tab Donadoras del detalle de cliente: donadoras co-poseídas (admin-client-holdings.md · 0105)
// con su % de co-posesión, grado y participación económica. Datos del holdings (fetch en el detalle).
export default function DonorsTab({ donors = [], isLoading, error }) {
    return (
        <section className="client-detail__card">
            <div className="client-detail__section-head">
                <h2 className="client-detail__section-title">Donadoras {!isLoading && <span className="client-detail__count">{donors.length}</span>}</h2>
            </div>

            {isLoading ? (
                <p className="client-detail__muted">Cargando donadoras…</p>
            ) : error ? (
                <p className="client-detail__muted">No se pudieron cargar las donadoras.</p>
            ) : !donors.length ? (
                <p className="client-detail__muted">Este cliente no tiene donadoras co-poseídas.</p>
            ) : (
                <table className="cat-table cat-table--compact">
                    <thead>
                        <tr><th>Donadora</th><th>%</th><th>Grado</th><th>Participación</th><th className="cat-table__actions-col" aria-label="Acciones" /></tr>
                    </thead>
                    <tbody>
                        {donors.map((d) => (
                            <tr key={d.id} className="cat-table__row">
                                <td>
                                    <Gate domain="animals" action="read" fallback={<span className="cat-table__name">{d.name || d.number || `#${d.id}`}</span>}>
                                        <Link to={`/admin/animals/${d.id}`} className="cat-table__name">{d.name || d.number || `#${d.id}`}</Link>
                                    </Gate>
                                    {d.number && d.name && <span className="hld__sub"> · {d.number}</span>}
                                </td>
                                <td><span className="hld-pct">{Number(d.percent)}%</span></td>
                                <td>{d.grade ? <span className="hld-grade">{d.grade}{d.final_score != null ? ` · ${d.final_score}` : ''}</span> : <span className="cat-table__empty">—</span>}</td>
                                <td>{fmtMoney(d.stake_value)}</td>
                                <td className="cat-table__actions">
                                    <Gate domain="kpis" action="read">
                                        <Link to={`/admin/animals/${d.id}/stats`} className="cat-table__edit" aria-label="Estadísticas" title="Estadísticas"><IconChart /></Link>
                                    </Gate>
                                    <Gate domain="animals" action="write">
                                        <Link to={`/admin/animals/${d.id}/edit`} className="cat-table__edit" aria-label="Editar" title="Editar"><IconEdit /></Link>
                                    </Gate>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </section>
    );
}
